export const rightPanelMenuItem = ["Contact Info", "Business Details"];
export const leftPanelMenuItem = ["Contact Info", "Business Details"];
